
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adm/[slug]",
      function () {
        return require("private-next-pages/adm/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/adm/[slug]"])
      });
    }
  